import { useTranslation } from "react-i18next";
import SEO from "@/components/site/SEO";
import { orgSchema } from "@/lib/seo";
import Hero from "@/components/home/Hero";
import ClientStrip from "@/components/home/ClientStrip";
import Manifesto from "@/components/home/Manifesto";
import BrandVideo from "@/components/home/BrandVideo";
import SelectedWork from "@/components/home/SelectedWork";
import Services from "@/components/home/Services";
import Founder from "@/components/home/Founder";
import Impact from "@/components/home/Impact";
import CaseStudies from "@/components/home/CaseStudies";
import Industries from "@/components/home/Industries";
import Process from "@/components/home/Process";
import Testimonials from "@/components/home/Testimonials";
import Insights from "@/components/home/Insights";
import LatestBlogs from "@/components/home/LatestBlogs";
import CTASection from "@/components/home/CTASection";
import Marquee from "@/components/site/Marquee";

export default function Home() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title={t("meta.title")}
        description={t("meta.description")}
        path="/"
        schema={orgSchema()}
      />
      <Hero />
      <ClientStrip />
      <Manifesto />
      <BrandVideo />
      <SelectedWork />
      <Services />
      <Marquee />
      <Founder />
      <Impact />
      <CaseStudies />
      <Industries />
      <Process />
      <Testimonials />
      <Insights />
      <LatestBlogs />
      <CTASection />
    </>
  );
}
